import { PencilIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Button, ButtonGroup, Card, CardBody, CardFooter, Dialog, Input } from '@material-tailwind/react'
import React from 'react'
import AutocompleteUser from '../ManageWarehouse/AutocompleteUser'
import AutocompleteDeliveryAddress from './AutocompleteDeliveryAddress'

const DilveryModal = ({ handleDilveryModal, user, userList, setDilveryModal, AddDilveryAdress, dilveryModal,
  deliveryAddress, setdeliveryAddress, deliveryName, setdeliveryName, deliveryPhone, setdeliveryPhone, deliveryCompanyName, setdeliveryCompanyName, deliveryPincode, setdeliveryPincode,
  deliveryCity, setdeliveryCity, deliveryState, setdeliveryState, setUser, deliveryClientId, setdeliveryClientId,
  deliveryAddresses = []
}) => {

	return (
		<div>
			<div>
				<Dialog
					size="md"
					open={dilveryModal}
					handler={handleDilveryModal}
					className="bg-transparent  shadow-none"
				>
					<Card className="lg:mx-auto  relative    w-full ">
                    <div className='px-6 pt-4 flex items-center justify-between' >
                        <div className='' >
                            <h3 className='text-[1.4rem] font-[GilroyBold]' >Add dilvery Address</h3>
                        </div>
                        <div onClick={handleDilveryModal} className=" cursor-pointer w-[40px] h-[40px]" >
                            <XMarkIcon className='w-[30px]' />
                        </div>
                    </div>
                    <CardBody className="h-[50vh] overflow-y-scroll ">
                        {/* Saved address autocomplete */}
                        <div className='mb-4'>
                          <AutocompleteDeliveryAddress
                            data={deliveryAddresses}
                            onSelect={(row) => {
                              if (!row) return
                              setdeliveryCompanyName(row.deliveryCompanyName || '')
                              setdeliveryName(row.deliveryName || '')
                              setdeliveryPhone(row.deliveryPhone || '')
                              setdeliveryAddress(row.deliveryAddress || '')
                              setdeliveryPincode(row.deliveryPincode || '')
                              setdeliveryCity(row.deliveryCity || '')
                              setdeliveryState(row.deliveryState || '')
                              if (row.deliveryClientId) {
                                setdeliveryClientId(row.deliveryClientId)
                              }
                            }}
                            placeholder='Search saved delivery addresses'
                          />
                        </div>
                        <div className='flex gap-5 justify-center items-center'>
                            <div className='w-[300px]'>
                                <Input value={deliveryCompanyName} onChange={(e) => setdeliveryCompanyName(e.target.value)} label='Company Name' />
                            </div>
								<div className='w-[300px]'>
									<Input value={deliveryName} onChange={(e) => setdeliveryName(e.target.value)} label='Consignee Name' />
								</div>
							</div>
							<div className='flex mt-5 gap-4 justify-center items-center'>
								<div className='w-[300px]'>
									<Input value={deliveryPhone} onChange={(e) => setdeliveryPhone(e.target.value)} label='Contact No' />
								</div>
								<div className='w-[300px]'>
									<Input value={deliveryAddress} onChange={(e) => setdeliveryAddress(e.target.value)} label='Address' />
								</div>
							</div>
							<div className='flex mt-5 gap-4 justify-center items-center'>
								<div className='w-[300px]'>
									<Input value={deliveryPincode} onChange={(e) => setdeliveryPincode(e.target.value)} label='Pincode' />
								</div>
								<div className='w-[300px]'>
									<Input value={deliveryCity} onChange={(e) => setdeliveryCity(e.target.value)} label='City' />
								</div>
							</div>
                        <div className='flex mt-5 gap-4 justify-start items-center'>
                            <div className='w-[270px]'>
                                <Input value={deliveryState} onChange={(e) => setdeliveryState(e.target.value)} label='State' />

                            </div>
                            <div className='w-[270px]'>
                                {Object.keys(deliveryClientId).length === 0 ? (
                                    <AutocompleteUser
                                        selected={deliveryClientId}
                                        setSelected={setdeliveryClientId}
                                        placeholder="Enter Client Name"
                                        data={userList}
                                    />
                                ) : (
                                    <div>
                                        <div className=' flex items-center justify-end'>
                                            <PencilIcon className='w-[25px] cursor-pointer' onClick={() => setdeliveryClientId({})} />
                                        </div>
                                        <h3 className='text-[.8rem]'>{deliveryClientId.name}, {deliveryClientId.email}</h3>
                                        <h3 className='text-[.8rem]'>{deliveryClientId.companyName}</h3>
                                    </div>
                                )}
                            </div>
                        </div>
						</CardBody>
						<CardFooter className="border-t-1 border-gray-300 bg-gray-200 flex items-center justify-end gap-3">
							<Button onClick={AddDilveryAdress}>Submit</Button>
						</CardFooter>
					</Card>
				</Dialog>
			</div>
		</div>
	)
}

export default DilveryModal
